<template>
  <div class="animated">
    <SampleServerTable
      v-if="sample_collection"
      :collection="sample_collection"
    />
  </div>
</template>

<script>
import SampleCollection from '@/collections/lab/SampleCollection'
import SampleServerTable from '@/components/lab/samples/SampleServerTable.vue'

export default {
  name: 'ProjectSampleTable',
  components: {
    SampleServerTable
  },
  props: {
    project: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      sample_collection: null
    }
  },
  async created () {
    const collection = new SampleCollection()
    const filter = collection.getFilter()
    filter.filterEquals('submission.project_id', this.project.id)

    filter.cacheStaticFilters()
    this.sample_collection = collection
  }
}
</script>
